import { SearchProvider } from 'contexts/SearchContext';
import { NextSeo } from 'next-seo';
import React from 'react';

import Footer from '../../../components/Footer';
import SearchPage from 'components/search/SearchPage';
import pages from '../../../config/pages';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { fetchAreas, fetchCategories } from 'data/fetchers';

export async function getStaticPaths() {
    return { paths: [], fallback: 'blocking' };
}

// This also gets called at build time
export async function getStaticProps({ params }) {
    const queryClient = new QueryClient();
    await queryClient.prefetchQuery('areas', () => fetchAreas());
    await queryClient.prefetchQuery('categories', () => fetchCategories({}));

    return {
        props: {
            dehydratedState: dehydrate(queryClient),
            params
        },
        revalidate: 60 * 60 * 12 // In seconds
    };
}

const IdeasByInterestOrArea = ({ params }) => {
    const { data: areas } = useQuery('areas', () => fetchAreas());

    const { data: categories } = useQuery('categories', () => fetchCategories({}));

    const { category_or_location } = params;

    const searchParams = {
        category: null,
        area: null
    };

    let pageMeta;

    if (categories.data.find((i) => i.slug === category_or_location)) {
        const category = categories.data.find((i) => i.slug === category_or_location);
        searchParams.category = category;
        pageMeta = pages.ideas.category(category);
    } else {
        const area = areas.data.find((area) => area.slug === category_or_location);
        searchParams.area = area;
        pageMeta = pages.ideas.area(area);
    }

    return (
        <div className="single-page ideas">
            <NextSeo
                title={pageMeta.title}
                description={pageMeta.seo.description}
                openGraph={{
                    title: `${pageMeta.title} | Kam za vikend`,
                    description: pageMeta.seo.description,
                    url: pageMeta.seo.url
                }}
            />
            <SearchProvider {...searchParams} categories={categories.data}>
                <SearchPage />
            </SearchProvider>
            <Footer />
        </div>
    );
};

export default IdeasByInterestOrArea;
